<template>
  <div class="main-msg-box">
    <div class="associate" v-if="isLike && likeList.length">
      <ul>
        <li
          @click="handleClick(item)"
          v-for="item in likeList"
          :key="item.id"
          v-html="getHighlightWords(item.question)"
        ></li>
      </ul>
    </div>
    <div class="option-btn">
      <div class="btn-item" @click="handleOption(1)">
        <img src="../../assets/img/service_list.png" class="icon-img" alt="" />
        <span>{{ $t("im.服务进度查询") }}</span>
      </div>
      <div class="btn-item" @click="handleOption(2)">
        <img src="../../assets/img/custom_report.png" class="icon-img" alt="" />
        <span>{{ $t("im.自主提交") }}</span>
      </div>
      <div
        v-for="item in fastEntrys"
        :key="item.id"
        class="btn-item"
        @click="handleReport(item)"
      >
        {{ item.name }}
      </div>
    </div>
    <div @click.stop="() => {}" :class="['send-msg', show ? 'out' : 'in']">
      <input
        v-model="value"
        id="input"
        class="input"
        :placeholder="placeholder"
        v-input="{ up: handleFocus, down: handleBlur }"
        @blur="handleBlur"
        @focus="focus"
        @keydown.enter="handleSubmit"
        type="text"
      />
      <div class="btn-group">
        <van-button
          v-show="value || isFocus || !showOther"
          @click="handleSubmit"
          :class="['send-btn', showOther && !isFocus ? 'marginR10' : '']"
          type="primary"
          >{{ text }}
        </van-button>
        <van-icon
          class="other-btn"
          v-show="showOther && !isFocus"
          @click="show = !show"
          size="30"
          color="#CDA65E"
          name="add-o"
        />
      </div>
      <div :class="['other-options', show ? 'in' : '']">
        <div v-show="show">
          <van-uploader
            accept="image/*"
            multiple
            :max-count="9"
            :after-read="afterImgRead"
          >
            <div class="upload-box 222">
              <van-icon size="50" class="kf-img" />
              <span>{{ $t("im.发送图片") }}</span>
            </div>
          </van-uploader>
          <van-uploader
            v-if="!isHideVideo && !hideVideo"
            accept="*"
            :after-read="afterVideoRead"
            class="marginL20"
          >
            <div class="upload-box">
              <van-icon size="50" class="kf-video" />
              <span>{{ $t("im.发送视频") }}</span>
            </div>
          </van-uploader>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { uploadFileOss } from "@/utils/uploadOss";
import { apiLikeQuestion } from "@/api/Im";
import { debounce, getUrlQuery } from "@/utils/util";
import { mapGetters, mapActions } from "vuex";

export default {
  props: {
    fastEntrys: {
      type: Array,
      default: () => [],
    },
    text: {
      type: String,
      default: "发送",
    },
    showOther: {
      type: Boolean,
      default: false,
    },
    cdn: {
      type: String,
      default: "",
    },
    isLike: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "",
    },
    hideVideo: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    document.addEventListener("click", () => {
      this.show = false;
    });
    const isHideVideo = sessionStorage.getItem("is_hide_v");
    if (isHideVideo) {
      this.isHideVideo = true;
    }
  },
  data() {
    return {
      value: "",
      show: false,
      isFocus: false,
      // 为了兼容ios
      isSubmit: false,
      likeList: [],
      isHideVideo: false,
    };
  },
  computed: {
    ...mapGetters(["vuexInitData", "defaultRoleInfo"]),
  },
  watch: {
    show(val) {
      if (val) {
        this.$emit("focus");
      }
    },
    value(val) {
      if (this.isLike) {
        if (val) {
          this.getLike(val);
        } else {
          this.likeList = [];
        }
      }
    },
  },
  methods: {
    ...mapActions(["checkLogin"]),
    handleFocus() {
      this.show = false;
      this.isFocus = true;
      this.$emit("focus");
    },
    handleBlur() {
      // 这为了ios 做的 不要乱动
      setTimeout(() => {
        if (!this.isSubmit) {
          this.isFocus = false;
          this.$emit("blur");
        }
        this.isSubmit = false;
      }, 10);
    },
    handleEnd() {
      // console.log(111);
    },
    getHighlightWords(str) {
      return str.replace(
        this.value,
        `<span style="color: #CDA65E">${this.value}</span>`,
      );
    },
    // 服务进度和自主提交
    handleOption(type) {
      this.checkLogin()
        .then(() => {
          if (
            !this.defaultRoleInfo.id ||
            this.defaultRoleInfo.id === "tourist" ||
            this.defaultRoleInfo.is_guest === 1
          ) {
            this.$router.push({
              name: "BindRoles",
            });
            return;
          }
          if (type === 1) {
            this.$router.push({
              name: "ReportHistory",
            });
          } else {
            this.$router.push({
              path: "/report",
              query: {
                title: this.$t("reportIndex.更多问题"),
                formToken: 1,
                id: 1,
              },
            });
          }
        })
        .catch(() => {
          this.$eventBus.$emit("showLogin");
        });
    },
    handleReport(item) {
      this.checkLogin()
        .then(() => {
          console.log(2234, this.defaultRoleInfo);
          if (
            !this.defaultRoleInfo.id ||
            this.defaultRoleInfo.id === "tourist" ||
            Number(this.defaultRoleInfo.is_guest) === 1
          ) {
            this.$router.push({
              name: "BindRoles",
            });
            return;
          }
          let query = getUrlQuery(item.url);
          let pathDict = [
            "/change-phone",
            "/ban-query",
            "/props-flow",
            "/special-props-flow",
            "/account-info",
            "/rebates-query",
          ];
          for (let i = 0; i < pathDict.length; i++) {
            if (item.url.includes(pathDict[i])) {
              this.$router.push({
                path: pathDict[i],
                query,
              });
              return;
            }
          }
          if (!item.token && !item.form_id) {
            window.open(item.url);
          } else {
            this.$router.push({
              name: "Report",
              query: {
                formToken: item.token,
                id: item.form_id,
                title: item.name,
              },
            });
          }
        })
        .catch(() => {
          this.$eventBus.$emit("showLogin");
        });
    },
    handleSubmit() {
      if (!this.value) {
        this.$toast(this.$t("im.请输入内容"));
        setTimeout(() => {
          this.focus();
          return;
        }, 20);
      }
      this.isSubmit = true;
      this.focus();
      this.likeList = [];
      this.$emit("submit", this.value);
    },
    clearValue() {
      this.value = "";
    },

    afterImgRead(file) {
      const files = Array.isArray(file) ? file : [file];
      if (files.length > 9) {
        this.$toast(this.$t("最多支持9张图片") || "最多支持9张图片");
        return;
      }
      this.afterBatchImgRead(files);
    },
    validateImgFile(file) {
      const size = 10 * 1024 * 1024;
      if (file.file.size > size) {
        this.$toast(this.$t("文件超出大小限制"));
        return false;
      }
      const allowTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/gif",
        "image/heic",
      ];
      if (!allowTypes.includes(file.file.type)) {
        this.$toast(this.$t("请上传正确的图片格式"));
        return false;
      }
      return true;
    },
    afterBatchImgRead(files) {
      for (const file of files) {
        if (!this.validateImgFile(file)) return;
      }
      const tmp_id = new Date().getTime();
      const previewContent = files
        .map((f) => `<img src='${f.content}'/>`)
        .join("");
      this.$emit("uping", {
        type: "img",
        files,
        tmp_id,
        content: previewContent,
      });
      this.show = false;
      Promise.all(files.map((f) => uploadFileOss({ file: f.file })))
        .then((results) => {
          const urls = results.map((res) => res.key);
          const content = urls.map((url) => `<img src='${url}'>`).join("");
          this.$emit("imgSuccess", { urls, content, tmp_id, type: "img" });
        })
        .catch((err) => {
          const msg =
            (err && err.msg) ||
            (err && err.message) ||
            this.$t("reportIndex.上传失败");
          this.$toast(msg);
          this.$emit("uploadFail", { type: "img", tmp_id, err });
        });
    },
    focus() {
      this.isFocus = true;
      document.getElementById("input").focus();
    },
    afterVideoRead(file) {
      let params = {
        file: file.file,
      };
      console.log(file);
      this.afterRead(file, params, "video");
    },
    beforeVideoRead(file) {
      console.log(file);
      let uploadUrl = URL.createObjectURL(file);
      console.log(uploadUrl);
      return true;
    },
    afterRead(file, params, type) {
      // 如果是图片，限制大小不能超过10Mb，视频不能超过100Mb
      let size = type === "img" ? 10 * 1024 * 1024 : 100 * 1024 * 1024;
      if (file.file.size > size) {
        this.$toast(this.$t("文件超出大小限制"));
        return;
      }

      // 判断文件格式
      if (type === "video") {
        let allowTypes = [
          "video/mp4",
          "video/avi",
          "video/mov",
          "video/wmv",
          "video/hevc",
        ];
        if (!allowTypes.includes(file.file.type)) {
          this.$toast(this.$t("请上传正确的视频格式"));
          return;
        }
      }
      if (type === "img") {
        // 苹果手机拍照上传的图片格式是image/heic，需要转换，图片格式全一点
        let allowTypes = [
          "image/jpeg",
          "image/jpg",
          "image/png",
          "image/gif",
          "image/heic",
        ];
        if (!allowTypes.includes(file.file.type)) {
          this.$toast(this.$t("请上传正确的图片格式"));
          return;
        }
      }

      let tmp_id = new Date().getTime();
      this.$emit("uping", { type, file, tmp_id });
      this.show = false;
      uploadFileOss(params)
        .then((res) => {
          const url = res.key;
          console.log(url);
          this.$emit(type === "img" ? "imgSuccess" : "videoSuccess", {
            url,
            type,
            tmp_id,
          });
        })
        .catch((err) => {
          const msg =
            (err && err.msg) ||
            (err && err.message) ||
            this.$t("reportIndex.上传失败");
          this.$toast(msg);
          this.$emit("uploadFail", { type, tmp_id, err });
        });
    },
    getLike: debounce(function (key_words) {
      apiLikeQuestion({ key_words }).then((res) => {
        if (res.code === 0) {
          if (this.value) {
            this.likeList = res.data.slice(0, 5);
          }
        }
      });
    }),
    handleClick(item) {
      this.value = "";
      this.$emit("submit", item.question, item.id);
    },
  },
};
</script>

<style lang="less" scoped>
::-webkit-scrollbar {
  display: none;
}
.main-msg-box {
  position: relative;
  .option-btn {
    width: 100%;
    display: flex;
    align-items: center;
    // margin-bottom: 12px;
    padding: 10px;
    overflow: auto;
    box-sizing: border-box;

    // padding: 4px 4px;
    // background: #fff;
    .btn-item {
      flex: 0 0 auto;
      display: flex;
      align-items: center;
      font-size: 13px;
      height: 36px;
      margin-right: 10px;
      padding: 0 10px;
      color: #666;
      text-align: center;
      border-radius: 10px;
      background-color: #fff;
      &:last-child {
        margin-right: 0;
      }
      .icon-img {
        margin-right: 4px;
        width: 16px;
        height: 16px;
      }
    }
  }
}
.send-msg {
  position: relative;
  display: flex;
  z-index: 100;
  // align-items: center;
  padding: 10px;
  height: 34px;
  background: #fff;
  &.show {
    height: 120px;
  }

  &.in {
    // transition: height .3s ease-in;
  }

  &.out {
    height: 120px;
    transition: height 0.2s ease-out;
  }

  .input {
    flex: 1;
    height: 28px;
    background: none;
    outline: none;
    border-radius: 30px;
    background: #e9e9e9;
    padding: 3px 10px;
    border: none;
    font-size: 13px;
  }

  .btn-group {
    height: 34px;
    display: flex;
    align-items: center;
    margin-left: 10px;
  }
  .send-btn {
    // margin-right: 10px;
  }
  .other-btn {
    color: #545454;
    // margin-left: 10px;
  }

  .other-options {
    position: absolute;
    bottom: 0;
    width: calc(100% - 40px);
    height: 0;

    &.in {
      height: 80px;
      transition: 0.3s ease-in;
    }
  }
}
.upload-box {
  display: flex;
  flex-direction: column;
}
.associate {
  z-index: 999;
  position: absolute;
  bottom: 54px;
  width: 100%;
  padding: 0 10px;
  box-sizing: border-box;
  // border-bottom: 1px solid #d8d8d8;
  background-color: #fff;
  li {
    width: 100%;
    padding: 15px 0;
    font-size: 14px;
    font-weight: 500;
    color: #333;
    box-sizing: border-box;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  li + li {
    border-top: 1px solid rgba(0, 0, 0, 0.04);
  }
}
</style>
